<!-- AddImprintLocationButton.vue - Button to add another imprint location -->
<template>
  <div class="button-container">
    <button 
      class="add-imprint-btn"
      :disabled="!hasAdditionalLocationFeeData"
      :title="!hasAdditionalLocationFeeData ? 'Additional location pricing is not available for this product' : ''"
      @click="handleClick"
    >
      + Add Another Imprint Location
    </button>
  </div>
</template>

<script>
import { useImprintStore } from '../stores/useImprintStore.js';
export default {
  name: 'AddImprintLocationButton',
  computed: {
      hasAdditionalLocationFeeData() {
          return useImprintStore().hasAdditionalLocationFeeData;
      }
  },
  methods: {
    handleClick() {
      if (!this.hasAdditionalLocationFeeData) return;
      this.$emit('add-imprint');
    }
  }
};
</script>

<style scoped lang="scss">
@use '@/styles/utils' as *;

.button-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 0;
  gap: 10px;
}

.add-imprint-btn {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  gap: 10px;
  
  width: 250px;
  height: 30px;
  
  background: $color-white;
  border: 1px solid $brand-secondary;
  border-radius: 3px;
  
  font-family: $font-family-base;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: $brand-secondary;
  
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: $brand-primary-lighter;
    border-color: $brand-primary;
    color: $brand-primary;
  }
  
  &:active {
    background: $brand-primary-lighter;
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: auto; // keep tooltip working

    &:hover {
      background: $color-white;
      border-color: $brand-secondary;
      color: $brand-secondary;
    }
  }
}
</style>
